import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../Api/Auth";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";
import { Base_URL, tempURl, windowURL } from "../url";
import { useAuth } from "../Context/AuthContext";
import "../Styling/Login.css";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [loginMethod, setLoginMethod] = useState("password");
  const [showChangePassword, setShowChangePassword] = useState(false);

  //   console.log(login, 'login');
  // ✅ Start Microsoft login (redirect to backend)
  const handleMicrosoftLogin = () => {
    //  window.location.href = ('${windowURL}');
    //   window.location.href = "https://mavrobackend2-ecb8erc4bmd7edcw.centralindia-01.azurewebsites.net/auth/Login";
    window.location.href = `${tempURl}/auth/microsoft/login`;
  };

  // ✅ Handle Password Login
  const handlePasswordLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      login(username, password);
    } catch (err) {
      const errorMessage = err.message || "Invalid username or password";
      setError(errorMessage);
      toast.error(`❌ ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  };

  // Signup Form Component
  const SignupForm = ({ setShowSignup }) => {
    const [signupData, setSignupData] = useState({
      username: "",
      email: "",
      password: "",
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handleSignup = async (e) => {
      e.preventDefault();
      setLoading(true);
      setError("");
      console.log(signupData);

      try {
        const response = await fetch(`${Base_URL}/Signup`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(signupData),
        });

        const data = await response.json();

        if (response.ok) {
          toast.success("🎉 Signup Successful! Please log in.");
          setShowSignup(false);
        } else {
          const errorMessage = data.message || "Signup failed. Try again.";
          setError(errorMessage);
          toast.error(`🦄 ${errorMessage}`);
        }
      } catch (err) {
        const errorMessage = err.message || "Something went wrong.";
        setError(errorMessage);
        toast.error(`🦄 ${errorMessage}`);
      } finally {
        setLoading(false);
      }
    };

    return (
      <div className="login-card">
        <h2 className="login-title">Sign Up</h2>
        {error && <p className="error-text">{error}</p>}
        <form onSubmit={handleSignup}>
          <div className="input-group">
            <label>Username</label>
            <input
              type="text"
              value={signupData.username}
              onChange={(e) =>
                setSignupData({ ...signupData, username: e.target.value })
              }
              required
              disabled={loading}
            />
          </div>
          <div className="input-group">
            <label>Email</label>
            <input
              type="email"
              value={signupData.email}
              onChange={(e) =>
                setSignupData({ ...signupData, email: e.target.value })
              }
              required
              disabled={loading}
            />
          </div>
          <div className="input-group">
            <label>Password</label>
            <div className="password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                value={signupData.password}
                onChange={(e) =>
                  setSignupData({ ...signupData, password: e.target.value })
                }
                required
                disabled={loading}
              />
              <button
                type="button"
                className="eye-button"
                onClick={() => setShowPassword(!showPassword)}
                disabled={loading}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>
          <button type="submit" className="login-button" disabled={loading}>
            {loading ? "Signing up..." : "Sign Up"}
          </button>
        </form>
        <p className="signup-text">
          Already have an account?{" "}
          <span onClick={() => setShowSignup(false)}>Login</span>
        </p>
      </div>
    );
  };
  const ChangePasswordModal = ({ onClose }) => {
  const [formData, setFormData] = useState({
    userName: "",
    password: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // if (formData.password !== formData.confirmPassword) {
    //   toast.error("Passwords do not match");
    //   return;
    // }

    try {
      setLoading(true);

      const response = await fetch(`${Base_URL}/Logins/UpdatePassword`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.text();

      if (response.ok) {
        toast.success("✅ Password updated successfully");
        onClose();
      } else {
        toast.error(data || "Failed to update password");
      }
    } catch (err) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <h3>Change Password</h3>

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label>Username</label>
            <input
              type="text"
              value={formData.userName}
              onChange={(e) =>
                setFormData({ ...formData, userName: e.target.value })
              }
              required
            />
          </div>

          <div className="input-group">
            <label>Current Password</label>
            <div className="password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                value={formData.password}
                onChange={(e) =>
                  setFormData({ ...formData, password: e.target.value })
                }
                required
              />
              <button
                type="button"
                className="eye-button"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          <div className="input-group">
            <label>New Password</label>
            <div className="password-wrapper">
              <input
                type={showConfirmPassword ? "text" : "password"}
                value={formData.confirmPassword}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    confirmPassword: e.target.value,
                  })
                }
                required
              />
              <button
                type="button"
                className="eye-button"
                onClick={() =>
                  setShowConfirmPassword(!showConfirmPassword)
                }
              >
                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          <div className="modal-actions">
            <button
              type="button"
              className="secondary-btn"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button type="submit" className="login-button" disabled={loading}>
              {loading ? "Updating..." : "Update Password"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

  return (
    <div className="login-container">
      <div className="login-method-selector">
        <button
          className={`method-tab ${loginMethod === "password" ? "active" : ""}`}
          onClick={() => setLoginMethod("password")}
        >
          Sign in with Password
        </button>
        <button
          className={`method-tab ${
            loginMethod === "microsoft" ? "active" : ""
          }`}
          onClick={() => setLoginMethod("microsoft")}
        >
          Sign in with Microsoft
        </button>
      </div>

      {!showSignup ? (
        <div className="login-card">
          <h2 className="login-title">
            {loginMethod === "password" ? "Password Login" : "Microsoft Login"}
          </h2>

          {error && <p className="error-text">{error}</p>}

          {loginMethod === "password" ? (
            <form onSubmit={handlePasswordLogin}>
              <div className="input-group">
                <label>Username</label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
              <div className="input-group">
                <label>Password</label>
                <div className="password-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    disabled={loading}
                  />
                  <button
                    type="button"
                    className="eye-button"
                    onClick={() => setShowPassword(!showPassword)}
                    disabled={loading}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>
              <button type="submit" className="login-button" disabled={loading}>
                {loading ? "Logging in..." : "Login with Password"}
              </button>
              <p className="forgot-password-text">
  <span onClick={() => setShowChangePassword(true)}>
    Change Password?
  </span>
</p>

            </form>
          ) : (
            <div className="microsoft-login-section">
              <p className="microsoft-description">
                Sign in using your Microsoft account
              </p>
              <button
                onClick={handleMicrosoftLogin}
                className="microsoft-login-button"
                disabled={loading}
              >
                <img
                  src="https://docs.microsoft.com/en-us/azure/active-directory/develop/media/howto-add-branding-in-azure-ad-apps/ms-symbollockup_signin_light.png"
                  alt="Microsoft"
                  className="microsoft-logo"
                />
                {loading ? "Signing in..." : "Sign in with Microsoft"}
              </button>
              <p className="microsoft-note">
                Note: Your Microsoft email must be registered in our system
              </p>
            </div>
          )}

          <p className="signup-text">
            Don't have an account?{" "}
            <span onClick={() => setShowSignup(true)}>Sign up</span>
          </p>
        </div>
      ) : (
        <SignupForm setShowSignup={setShowSignup} />
      )}
      {showChangePassword && (
  <ChangePasswordModal
    onClose={() => setShowChangePassword(false)}
  />
)}

    </div>
  );
};

export default Login;
